/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanStateWeekItemDto
 */
export interface MonthPlanStateWeekItemDto {
  /**
   *
   * @type {number}
   * @memberof MonthPlanStateWeekItemDto
   */
  plan: number;
  /**
   *
   * @type {number}
   * @memberof MonthPlanStateWeekItemDto
   */
  fact: number;
}

export function MonthPlanStateWeekItemDtoFromJSON(json: any): MonthPlanStateWeekItemDto {
  return MonthPlanStateWeekItemDtoFromJSONTyped(json, false);
}

export function MonthPlanStateWeekItemDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanStateWeekItemDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    plan: json["plan"],
    fact: json["fact"],
  };
}

export function MonthPlanStateWeekItemDtoToJSON(value?: MonthPlanStateWeekItemDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    plan: value.plan,
    fact: value.fact,
  };
}
